__webpack_require__.p = "https://app.mguniversitykalolsavam.com/";